import React from 'react';
import heroImage from '../assets/hero-image.png'; // Import the image
import '../styles/Hero.css';
import { Link } from 'react-router-dom';

const Hero = () => {
    return (
      <div className="section-container"  id="header-section">
      <div className="hero-container">
        {/* Text and Image Content */}
        <div className="hero-content">
          <h1>
            <span className="main-text">It’s All About the</span>
            <span className="highlight">ROI</span>
          </h1>
          <p>
            Performance-driven agency with a focus on revenue growth and scalability.
          </p>
          <Link to="/lead-form" className="cta-button">Get Your FREE Growth Audit</Link>
        </div>
        <div className="hero-image">
          <img src={heroImage} alt="Hero" />
        </div>
  
        {/* Focus Points Section */}
        <div className="focus-points-home">
            <div className="focus-point-home">
            <div className="focus-icon-home"></div>
            <span>Woman Owned</span>
        </div>
        <div className="focus-point-home">
         <div className="focus-icon-home"></div>
            <span>Results Focused</span>
        </div>
        <div className="focus-point-home">
            <div className="focus-icon-home"></div>
            <span>Fractional CMO Services</span>
        </div>
        </div>
      </div>
      </div>
    );
  };
  
  export default Hero;

